module.exports = __webpack_public_path__ + "img/email-confirmation.351c3768.svg";